<template>
  <div id="app" class="container">
    <link href="https://fonts.googleapis.com/css?family=Noto+Sans+JP|Noto+Sans+KR|Noto+Sans+SC|Noto+Sans+TC&amp;subset=chinese-simplified,chinese-traditional,japanese,korean" rel="stylesheet">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>

<style scoped>

#app {
  font-family: 'Helvetica Neue,Helvetica,Arial,sans-serif';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  padding-left:0px;
  padding-right:0px;
}

#container {
    margin: 0px;
    padding:0px;
}

</style>
<style>
/*header .container img {*/
/*  display:none;    */
/*}*/
/*header .container.default {*/
/*    height: 50px !important;*/
/*}*/
.breadcrumb {
    margin-bottom: 0px !important;
}
.container {
    padding: 0px !important;
    max-width: 1175px !important;
}

header .container {
  margin-left: 0 !important;
  margin-right: 0 !important;
  max-width: inherit !important;
}

.jumbotron {
     padding-top: 0px !important;
     padding-bottom: 0px !important;
     margin-bottom: 0px !important;
}

h4 {
  padding: 0px;
}

/* width */
::-webkit-scrollbar {
    width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
    background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555; 
}

input[type='checkbox']{
  cursor: default;
}

input[type='checkbox']:hover{
  cursor: pointer;
}

.footer_partners .col-md-3:nth-child(2) {
    display: none;
}
.footer_partners .col-md-3:nth-child(3) {
    display: none;
}
</style>




// WEBPACK FOOTER //
// src/App.vue